import { CloseIcon } from "@chakra-ui/icons";
import { Flex, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { Dict } from "../../../defines";
import { AlertErrorIcon, AlertTriangleIcon } from "../../../icons";
import { MessageBoxProps } from "./MessageBox.types";
import { MessageBoxStyles } from "./styles";

const MessageBox: React.FC<MessageBoxProps> = ({
  title,
  text,
  icon = AlertErrorIcon,
  onClose,
  filled,
  type,
  ...rest
}) => {
  if (filled) {
    const style: Dict = MessageBoxStyles[type || "info"] || {};

    return (
      <Flex borderRadius={4} width="100%" {...rest}>
        <Flex
          borderRadius="4px 0px 0px 4px"
          w="74px"
          p={6}
          alignItems="flex-start"
          {...style.leftBox}
        >
          <Icon
            boxSize="24px"
            as={AlertTriangleIcon}
            color={"text.white"}
            {...style.icon}
          />
        </Flex>
        <Flex
          flex="1"
          borderRadius="0px 4px 4px 0px"
          p={6}
          alignItems="flex-start"
          justifyContent="space-between"
          direction={"column"}
          {...style.rightBox}
        >
          {title && <Text textStyle={"bodyRegularBold"}>{title}</Text>}
          {text && <Text textStyle={"bodyRegular"}>{text}</Text>}
          {onClose && (
            <Icon
              boxSize="24px"
              as={CloseIcon}
              color="icons.grey"
              onClick={onClose}
              cursor="pointer"
            />
          )}
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex borderRadius={4} width="100%" {...rest}>
      <Flex
        borderRadius="4px 0px 0px 4px"
        bg="semantic.error"
        w="74px"
        px="25px"
        alignItems="center"
      >
        <Icon boxSize="24px" as={icon} color="alert.danger" />
      </Flex>
      <Flex
        flex="1"
        py="25px"
        borderColor="border.input"
        borderWidth="1px"
        borderRadius="0px 4px 4px 0px"
        px="24px"
        alignItems="center"
        justifyContent="space-between"
      >
        <Text>{text}</Text>
        {onClose && (
          <Icon
            boxSize="24px"
            as={CloseIcon}
            color="icons.grey"
            onClick={onClose}
            cursor="pointer"
          />
        )}
      </Flex>
    </Flex>
  );
};

export default MessageBox;
